import { Component, HostListener, OnInit } from '@angular/core';
import { DropdownToggleService } from '../../../../../shared/services/dropdown-toggle.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-breadcrumb',
  standalone: false,
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.css',
})
export class BreadcrumbComponent implements OnInit {
  pageTitle= '';
  childPath = '';
  constructor(
    protected dropdownService: DropdownToggleService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}
  ngOnInit(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        mergeMap(route => route.data)
      )
      .subscribe(data => {
        this.pageTitle = data['title'] || '';
        // compute the current deepest child path so breadcrumb can show toggles
        const currentRoute = this.getChild(this.activatedRoute);
        this.childPath = currentRoute.snapshot.routeConfig?.path || '';
      });

    // Also set it immediately on page refresh
    const currentRoute = this.getChild(this.activatedRoute);
    this.pageTitle = currentRoute.snapshot.data['title'] || '';
    this.childPath = currentRoute.snapshot.routeConfig?.path || '';
  }

  private getChild(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  // Toggle a specific dropdown
  toggleDropdown(id: string, event: MouseEvent): void {
    event.stopPropagation();
    this.dropdownService.toggleDropdown(id);
  }

  openSecondaryDisplay() {
  
  // legacy - keep for secondary display use-case, but breadcrumb navigation will use router
  if ('getScreenDetails' in window) {
     // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).getScreenDetails().then((screenDetails: any) => {
      let secondScreen = screenDetails.screens[0];
      if (screenDetails.screens.length > 1) {
        secondScreen = screenDetails.screens[1];
      } else {
        console.log('Only one screen detected.');
      }
      // Kiosk-style options
      const features = [
          `left=${secondScreen.availLeft}`,
          `top=${secondScreen.availTop}`,
          `width=${secondScreen.width}`,
          `height=${secondScreen.height}`,
          'fullscreen=yes',
          'titlebar=no',
          'toolbar=no',
          'menubar=no',
          'status=no',
          'location=no',
          'resizable=yes',
          'scrollbars=no'
        ].join(',');
// if (this.isResourceSmartView) {
      // ✅ navigate to resource-board
      const newWindow = window.open(
          '/resource/board',
          'SecondaryDisplay',
          features
        );
//     } else {
//       // ✅ navigate back to default view
//       newWindow = window.open(
//           '/tickets/resources?view=by-ticket-count',
//           'SecondaryDisplay',
//           features
//         );
//     }

        

        if (newWindow) {
          try {
            // Focus & simulate fullscreen
            newWindow.focus();
            newWindow.moveTo(secondScreen.availLeft, secondScreen.availTop);
            newWindow.resizeTo(secondScreen.width, secondScreen.height+500);

            // Optional: try true fullscreen mode (user must allow interaction)
            newWindow.onload = () => {
              newWindow.document.documentElement.requestFullscreen?.().catch();
            };
          } catch (err) {
            console.warn('Maximize not allowed programmatically', err);
          }
        }
    });
  } else {
    alert('getScreenDetails API not supported in this browser.');
  }
}

  navigateToSummary(path: string): void {
    // navigate to tickets sub-route (absolute)
    this.router.navigate(['/', path]);
  }
  navigateToResourceBoard(): void {
    // navigate to tickets sub-route (absolute)
    this.router.navigate(['./resource-board'],
      { queryParams: { view: 'by-mainboard' } }
    );
  }

  // Check if a dropdown is visible
  isDropdownVisible(id: string): boolean {
    return this.dropdownService.isDropdownVisible(id);
  }

  onLinkClick(event: MouseEvent): void {
    event.stopPropagation();
    this.dropdownService.hideAllDropdowns();
  }

  // Hide all dropdowns when clicking anywhere else in the document
  @HostListener('document:click', ['$event'])
  onDocumentClick(): void {
    this.dropdownService.hideAllDropdowns();
  }

  onDivClick(event: MouseEvent): void {
    event.stopPropagation(); // Prevent document click listener from closing dropdown
  }
}
